// extracted by mini-css-extract-plugin
export var csatScore = "_mx-5";
export var header = "_mx-1";
export var panelWrapper = "_mx-2";
export var postPreview = "_mx-3";
export var rightContent = "_mx-0";
export var wrappingText = "_mx-4";